<mat-card class="feed-card" [class.inactive]="event.wasCancelled || isPast">
    <div class="feed-card-header">
        <span class="event-date">
            <span class="event-date-month">{{ event.date | date:'MMM' }}</span>
            <span class="event-date-day">{{ event.date | date:'dd' }}</span>
        </span>
        <div class="feed-card-heading">
            <div class="feed-card-title-row">
                <h3 class="feed-card-title">{{ event.title }}</h3>
                <span class="bg-label danger mat-small" *ngIf="event.wasCancelled">Cancelado</span>
                <span class="bg-label other mat-small" *ngIf="!event.wasCancelled && isPast">Encerrado</span>
            </div>
            <span class="feed-card-meta">
                <mat-icon>schedule</mat-icon>
                <span>{{ event.date | date:"EEEE, dd/MM/yyyy 'às' HH:mm" }}</span>
            </span>
            <span class="feed-card-meta" *ngIf="event.location">
                <mat-icon>place</mat-icon>
                <span>{{ event.location }}{{ event.locationBranch ? ' · ' + event.locationBranch : '' }}</span>
            </span>
        </div>
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Opções do evento"
            *ngIf="allowEventManagement && !event.wasCancelled">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editEvent()">
                <mat-icon>create</mat-icon>
                <span>Editar</span>
            </button>
            <button mat-menu-item (click)="cancelEvent()">
                <mat-icon>block</mat-icon>
                <span>Cancelar</span>
            </button>
            <button mat-menu-item (click)="viewPresenceList()">
                <mat-icon>groups</mat-icon>
                <span>Lista de presença</span>
            </button>
        </mat-menu>
    </div>

    <p class="feed-card-text" *ngIf="event.description" [innerHTML]="getEventDescription(event)"></p>

    <div class="feed-card-footer" *ngIf="event.createdBy != null">
        <span class="feed-card-stat">
            <mat-icon>person_outline</mat-icon>
            Criado por {{ event.createdBy }}
        </span>
    </div>
</mat-card>
